import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  rightElement?: React.ReactNode;
}

export default function Input({
  label,
  error,
  icon,
  rightElement,
  id,
  disabled,
  className = '',
  ...props
}: InputProps) {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={id}
          className="block text-[13px] font-medium text-ink-mid mb-1.5"
        >
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <span className="absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none flex items-center">
            {icon}
          </span>
        )}
        <input
          id={id}
          disabled={disabled}
          className={[
            'w-full py-3 text-[15px] text-ink-dark bg-white',
            'border rounded-sm outline-none',
            'transition-[border-color,box-shadow] duration-150',
            'placeholder:text-ink-soft placeholder:opacity-60',
            icon ? 'pl-11' : 'pl-3.5',
            rightElement ? 'pr-11' : 'pr-3.5',
            error
              ? 'border-accent-danger shadow-[0_0_0_3px_rgba(220,38,38,0.10)]'
              : 'border-stone-border focus:border-sage focus:shadow-[0_0_0_3px_rgba(107,128,104,0.13)]',
            disabled ? 'opacity-60 cursor-not-allowed' : '',
            className,
          ]
            .filter(Boolean)
            .join(' ')}
          {...props}
        />
        {rightElement && (
          <span className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center">
            {rightElement}
          </span>
        )}
      </div>
      {error && (
        <p className="mt-1 text-[12px] text-accent-danger">{error}</p>
      )}
    </div>
  );
}
